<div class="img">
	<fa-icon [icon]="['fas', 'user']" size="lg"></fa-icon>
</div>

<div class="meta">
	<p class="name">{{ name }}</p>
	<a class="logout" [routerLink]="[ '/logout' ]">Uitloggen</a>
</div>